import styled, { css } from 'styled-components'
import { respondModifiersToBreakpoints, applyRuleToBreakpoints } from '@styles/mixins'
import { grid } from '@styles/vars'

const Grid = styled.div<GridProps>`
    width: ${props => props.width || "100%"};
    display: grid;
    align-items: start;
    grid-template-columns: minmax(0, 1fr);
    grid-gap: 30px;

    & > h1, & > h2, & > h3, & > h4, & > h5, & > h6, & > p {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
    }

    ${respondModifiersToBreakpoints(grid.columns, "columns", columns => css`
        grid-template-columns: repeat(${columns}, minmax(0, 1fr));
    `)}

    ${props => {
        if (!props.gap) return
        return applyRuleToBreakpoints(props.gap, value => css`grid-gap: ${value};`)
    }}
`

export default Grid

// TYPES
export interface GridProps {
    width?: "auto"
    columns?: GridColumnsType
    gap?: string
}